'use client';

import { useState, type FC, type FormEvent, useContext } from 'react';
import { Button, ButtonGroup, Flex, Input, Text } from '@/_components';
import { LoginContext } from '@/_contexts/LoginProvider';
import type { TwoFactorAuthProps } from './TwoFactorAuth.types';
import { useSignInWithCode } from '@/_hooks/useSignInWithCode';
import { useRouter } from 'next/navigation';

export const TwoFactorAuth: FC<TwoFactorAuthProps> = ({
  isStandalone,
  onBackOverride,
}) => {
  const [verificationCode, setVerificationCode] = useState<string>('');
  const { twoFactorMessage, setLoginState } = useContext(LoginContext);

  const { push } = useRouter();
  const { isLoading, signInWithVerificationCode } = useSignInWithCode();

  const onSubmit = async (event: FormEvent) => {
    event?.preventDefault?.();

    try {
      await signInWithVerificationCode(verificationCode);
    } catch (error) {
      console.error(error);
    } finally {
      if (isStandalone) push('/');
    }
  };

  const onSetValue = (event: any) => {
    setVerificationCode(event?.target.value);
  };

  const onBack = () => {
    if (onBackOverride) return onBackOverride();

    setLoginState('login');
  };

  return (
    <form onSubmit={onSubmit}>
      <Flex isColumn={true} gap={8} padding={10}>
        <Text type="tiny" color="secondary">
          {twoFactorMessage}
        </Text>
        <Input
          label="One time code"
          isLabelHidden={true}
          type="text"
          placeholder="Your code"
          maxLength={6}
          value={verificationCode}
          onChange={onSetValue}
        />
        <ButtonGroup align="right">
          <Button
            value="Back"
            type="button"
            isDisabled={isLoading}
            intent="secondary"
            onClick={onBack}
          />
          <Button
            value="Submit Code"
            isLoading={isLoading}
            isDisabled={isLoading}
            type="submit"
            intent="primary"
          />
        </ButtonGroup>
      </Flex>
    </form>
  );
};
